<template>

  <div class="layout-wrapper">
    <!-- NAVBAR -->
    <nav class="navbar navbar-expand-lg navbar-dark navbar-scroll">

      <div class="container-fluid">
        <img
          v-if="header?.logo"
          :src="resolveImage(header.logo)"
          height="40"
          class="me-3"
        >
        <span class="navbar-brand fw-bold">
          {{ header?.title }}
        </span>
        <ul class="navbar-nav ms-auto">
          <li
            v-for="item in navigation"
            :key="item.path"
            class="nav-item"
          >
          <a
              class="nav-link text-white"
              style="cursor:pointer"
              @click="scrollTo(item.path)"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- HERO -->
    <section
      ref="hero"
      class="hero-section d-flex align-items-center justify-content-center"
      :style="heroStyle"
    >
      <div class="container text-center">
        <h1 class="display-4 fw-bold">
          {{ header?.title }}
        </h1>
        <p class="lead">
          {{ header?.subtitle }}
        </p>
      </div>
    </section>

    <!-- CONTENT -->
    <div class="content-wrapper">
      <section
        v-if="pages?.registration"
        id="registration"
        class="scroll-section py-5 bg-light"
      >
        <div class="container">
          <RegistrationPage :pages="pages"/>
        </div>
      </section>
      <section
        v-if="pages?.location"
        id="location"
        class="scroll-section py-5"
      >
        <div class="container">
          <LocationPage :pages="pages"/>
        </div>
      </section>

      <section
        v-if="pages?.contact"
        id="contatti"
        class="scroll-section py-5 bg-light"
      >
        <div class="container">
          <ContactPage :pages="pages"/>
        </div>
      </section>
      <footer class="footer text-center py-4 small bg-dark text-white-50">
        {{ footer?.text }}
      </footer>
    </div>
  </div>
</template>

<script>

import RegistrationPage from '@/pages/RegistrationPage.vue'
import LocationPage from '@/pages/LocationPage.vue'
import ContactPage from '@/pages/ContactPage.vue'

export default {

  name: 'ScrollPageLayout',

  components: {
    RegistrationPage,
    LocationPage,
    ContactPage
  },

  props: [
    'theme',
    'navigation',
    'header',
    'footer',
    'pages'
  ],

  data () {
    return {

      apiBase: process.env.VUE_APP_API,
      navbarHeight: 70,
      heroHeight: 300,
      heroGlowColor: 'rgba(0,0,0,0.5)',
      heroTextColor: '#ffffff'

    }
  },
  watch: {

    'theme.backgroundImage': {
      immediate: true,
      handler () {
        this.extractDominantColor()
      }
    }

  },

  computed: {
    heroStyle () {
      return {
        background: this.theme?.backgroundImage
          ? `url(${this.theme.backgroundImage}) center/cover no-repeat`
          : '#000',

        boxShadow: `
          0 4px 20px ${this.heroGlowColor},
          0 10px 40px ${this.heroGlowColor}`
      }
    }

  },

  mounted () {
    this.extractDominantColor()
  },

  methods: {

    resolveImage (path) {
      if (!path) return null
      if (path.startsWith('http')) return path
      return this.apiBase + path
    },

    scrollTo (id) {
      const el = document.getElementById(id)
      if (!el) return
      const offset = this.navbarHeight + this.heroHeight + 30
      const y =
        el.getBoundingClientRect().top +
        window.pageYOffset -
        offset

      window.scrollTo({
        top: y,
        behavior: 'smooth'

      })
    },

    extractDominantColor () {
      if (!this.theme?.backgroundImage) return

      const img = new Image()
      img.crossOrigin = 'Anonymous'
      // img.src = this.theme.backgroundImage
      const apiBase = process.env.VUE_APP_API
      const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      img.src = apiBase + '/proxy-image.php?url=' + encodeURIComponent(this.theme.backgroundImage) + '&controllo=' + session

      img.onload = () => {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        canvas.width = img.width
        canvas.height = img.height
        ctx.drawImage(img, 0, 0)
        const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data
        let r = 0; let g = 0; let b = 0; let count = 0
        for (let i = 0; i < data.length; i += 40) {
          r += data[i]
          g += data[i + 1]
          b += data[i + 2]
          count++
        }
        r = Math.floor(r / count)
        g = Math.floor(g / count)
        b = Math.floor(b / count)
        this.heroGlowColor = `rgba(${r},${g},${b},0.6)`
      }
    }
  }
}

</script>

<style scoped>
/* NAVBAR */

.navbar-scroll{
  position:fixed;
  top:0;
  width:100%;
  height:70px;
  z-index:1000;
  background:rgba(0,0,0,0.85);

}

/* HERO */

.hero-section{
  position:fixed;
  top:70px;
  width:100%;
  height:300px;
  z-index:900;
}

/* OVERLAY */

.overlay{
  position:absolute;
  inset:0;
  background:rgba(0,0,0,0.5);
}

/* CONTENT */

.content-wrapper{
  margin-top:400px;
}
/* FOOTER */

.footer{
  margin-top:auto;
}
</style>
